import { faArrowDownAZ, faLayerGroup, faStore } from "@fortawesome/free-solid-svg-icons"
import { Fragment, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import useFilter from "../../../../../hook/useFilter"
import useVariable from "../../../../../hook/useVariable"
import { producttypeActions } from "../../../../../store/producttype-slice"
import InfoIcon from "../../../../InfoIcon"
import Pagination from "./pagination"
import Resort from "./resort"
import { Link } from "react-router-dom"

export default function Filter({children}){


    const [showFilter, setShowFilter] = useState(false)

    let defaultproducttypecount = useSelector((state) => state.producttype.filterProducttypeCount)
    let pagination = useSelector((state) => state.producttype.pagination)
    let sliceFilters = useSelector(state => state.producttype.filter)
    let sliceActions = producttypeActions
    let sliceItems = useSelector(state => state.producttype.producttypes)

     const { doFilter } = useFilter()
        const { variableValue } = useVariable()

        const [paginationItems, setPaginationItems] = useState([])

        let dispatch=useDispatch()

        const [isMount, setIsMount] = useState(false)


        useEffect(() => {
            let items = []
            if (pagination) {
                pagination.map((item, key) => {
    
                    items.push(<Pagination key={key} producttyps={item} index={key} />)
                })
            }
    
            setPaginationItems(items)
        }, [pagination])



            useEffect(() => {
        
                if (!isMount) {
                    setIsMount(true)
                    return
                }
        
        
                doFilter(sliceFilters, sliceItems, sliceActions)
            }, [sliceFilters])



    return <div className="p-3" >
        <Link className="btn btn-outline-secondary bgnt mb-2" to='/admin/producttype' ><InfoIcon icon={faLayerGroup} />New Producttype</Link>
        <div className="card shadow  bg-white rounded p-3 mb-3" style={{ cursor: 'pointer' }} onClick={() => {
            setShowFilter(!showFilter)
        }}  >

            <InfoIcon icon={faArrowDownAZ} size='xl' />

        </div>
        {showFilter &&
            <Fragment>
                <label>Pagination</label><select name="filterPostCount" defaultValue={sliceFilters.pagination} className="mb-2" onChange={(event) => {
                    let value = variableValue(event.target.value)
                    dispatch(producttypeActions.setFilter({
                        key: 'pagination',
                        value
                    }))

                }} >
                    <option value='' >All</option>

                    {
                        defaultproducttypecount.map((item, key) => {

                            return <option key={key} value={item} >{item}</option>
                        })
                    }
                </select>

                <Resort type='id' name='ID' />
                <Resort type='title' name='Title' />
                <Resort type='created_on' name='CreatedOn' />
                
                
            </Fragment>}
        <input type="text" name="filter-email-username" className="mb-2" defaultValue={sliceFilters.search} placeholder="title" onInput={(event) => {
            let value = variableValue(event.target.value)

            dispatch(producttypeActions.setFilter({
                key: 'search',
                value
            }))


        }} />

        {children}

        <div className="pagination-container">{paginationItems}</div>
       
    </div>
}